import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Input,
  CustomInput,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  FormGroup,
  FormFeedback,
  InputGroup
} from 'reactstrap';
// import logolight from "../../assets/images/only-switch-logo.png";
// import logodark from "../../assets/images/only-switch-logo.png";
import logolight from "../../assets/images/sixbit-logo-bg.jpg";
import logodark from "../../assets/images/sixbit-logo-bg.jpg";
import { updateForm } from '../../store/form/actions';
import {
  clearEnableUserError,
  enableUserAccount,
  logoutUser
} from '../../store/actions';
import Message from '../../CommonData/Data/Message';
import success from '../../assets/images/success-msg.png';

const Register = (props) => {

  const { form, errorMessage, enableUserSuccess } = props;
  const { errors } = form || {};
  const params = useParams();
  const { code } = params || {};
  const naviagate = useNavigate();
  const [newPassword, setNewPassword] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState(true);
  const credits = window.__ENV && window.__ENV.credits;

  useEffect(() => {
    props.clearEnableUserError();
    props.updateForm({
      formAddPassword: {},
      errors: {}
    })
  }, [])

  const validateOnChange = (event) => {
    const { name, value } = event.target;
    props.updateForm({
      formAddPassword: {
        ...form.formAddPassword,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    })
  };

  const confirmPasswordInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      confirmPasswordInputRef.current.focus();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSubmit(e);
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();
    const { formAddPassword } = form || {};
    const { password, confirmPassword } = formAddPassword || {};

    const currentErrors = {};

    if (!password) {
      currentErrors.password = "Password is required"
    }
    if (!confirmPassword) {
      currentErrors.confirmPassword = "Confirm password is required"
    }
    props.updateForm({
      formAddPassword: {
        ...form.formAddPassword,
      },
      errors: currentErrors,
    })
    if (Object.keys(currentErrors).length === 0) {
      props.enableUserAccount(code);
    }
  }

  const handleLoginPage = () => {
    props.logoutUser();
    naviagate("/")
  }

  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card className='mt-5'>
                <CardBody className="p-4">
                  <div className="text-center">
                    <img
                      src={logodark}
                      alt=""
                      height="80"
                      className="auth-logo logo-dark mx-auto" />
                    <img
                      src={logolight}
                      alt=""
                      height="80"
                      className="auth-logo logo-light mx-auto" />
                  </div>
                  {!enableUserSuccess ?
                    <>
                      <div className="font-size-18 fw-bold text-dark text-muted mt-2 text-center">ENTER NEW PASSWORD</div>
                      <div className='mt-4'>
                        < div className="font-size-15 text-dark text-center ps-0 p-2 mb-2"> Please enter a new password in the fields below.</div>
                        <form className="form-horizontal" action="#">
                          <Row>
                            {errorMessage && (
                              <div >
                                <Message
                                  type="danger"
                                  defaultMessage={errorMessage}
                                  baseClassName="alert"
                                />
                              </div>
                            )}
                            <Col md={12}>
                              <FormGroup className='mb-4'>
                                <Label>Password</Label><span className="text-danger">*</span>
                                <InputGroup>
                                  <Input
                                    autoFocus
                                    innerRef={passwordInputRef}
                                    className={errors && errors.password ? "border-end-0" : 'border-end-0 border-secondary'}
                                    type={newPassword ? "password" : "text"}
                                    name="password"
                                    placeholder="Enter password"
                                    onChange={validateOnChange}
                                    onKeyPress={handleKeyDown}
                                    invalid={errors && errors.password}
                                  />
                                  <Button
                                    className={errors && errors.password ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
                                    color='white'
                                    onClick={() => setNewPassword(!newPassword)}
                                  >
                                    {newPassword ?
                                      <i className="fas fa-eye text-secondary"></i>
                                      :
                                      <i class="fas fa-eye-slash text-secondary"></i>
                                    }
                                  </Button>
                                  <FormFeedback>{errors && errors.password}</FormFeedback>
                                </InputGroup>
                              </FormGroup>
                              <FormGroup className='mb-4'>
                                <Label>Confirm Password</Label><span className="text-danger">*</span>
                                <InputGroup>
                                  <Input
                                    innerRef={confirmPasswordInputRef}
                                    className={errors && errors.confirmPassword ? "border-end-0 focus-ring focus-ring-primary" : 'border-end-0 border-secondary'}
                                    type={confirmPassword ? "password" : "text"}
                                    name="confirmPassword"
                                    placeholder="Enter confirm password"
                                    onChange={validateOnChange}
                                    onKeyPress={handleKeyPress}
                                    invalid={errors && errors.confirmPassword}
                                  />
                                  <Button
                                    className={errors && errors.confirmPassword ? "border-danger border-start-0 rounded-end  focus-ring focus-ring-primary" : 'border-secondary border-start-0 rounded-end'}
                                    color='white'
                                    onClick={() => setConfirmPassword(!confirmPassword)}
                                  >
                                    {confirmPassword ?
                                      <i className="fas fa-eye text-secondary"></i>
                                      :
                                      <i class="fas fa-eye-slash text-secondary"></i>
                                    }
                                  </Button>
                                  <FormFeedback>{errors && errors.confirmPassword}</FormFeedback>
                                </InputGroup>
                              </FormGroup>
                              <div className='d-grid gap-4 text-center'>
                                <Button
                                  color="primary"
                                  onClick={onSubmit}
                                  disabled={props.enableUserPending}
                                >
                                  {props.enableUserPending ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      Loading...
                                    </>
                                  ) : (
                                    "Confirm"
                                  )}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </form>
                      </div>
                    </>
                    :
                    <div className='text-center pt-2'>
                      <img
                        src={success}
                        alt=''
                        height='60'
                      />
                      <p className='text-success font-size-16 pt-2'>  {`${enableUserSuccess}'s account password was successfully updated...`}</p>
                      <Button
                        color="link"
                        className='text-decoration-underline text-info mt-4'
                        onClick={handleLoginPage}
                      >Go to login page
                      </Button>
                    </div>
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <div className="position-absolute bottom-0 start-50 translate-middle-x mt-5 text-center">
          <p className="text-white-50">
            © {new Date().getFullYear()} {credits}.
          </p>
        </div>
      </div >
    </React.Fragment >
  )
}

const mapStateToProps = (state) => ({
  form: state.form.form,
  errorMessage: state.login.enableUserError,
  enableUserSuccess: state.login.enableUserSuccess,
  enableUserPending: state.login.enableUserPending,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (AddPassword) => dispatch(updateForm(AddPassword)),
  enableUserAccount: (code) => dispatch(enableUserAccount(code)),
  clearEnableUserError: () => dispatch(clearEnableUserError()),
  logoutUser: () => dispatch(logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);




